<template>
  <!-- 业务规模 -->
  <div class="content-item white">
    <div class="content-items">
      <p class="title">业务规模</p>
      <span class="text">全球布局，让闲置更有价值</span>
      <div class="service-list">
        <div class="grade-item" v-for="(item, index) in gradeList" :key="index">
          <img :src="item.image" alt="">
          <div class="grade-title">
            <span class="number">{{item.number}}</span>
            <span>{{item.title}}</span>
          </div>
          <span>{{item.text}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      gradeList: [
        {
          image: require('../../assets/image/home/icon_yonghu.png'),
          number: '3200',
          title: '万+用户',
          text: '我们的用户'
        },
        {
          image: require('../../assets/image/home/icon_shebei.png'),
          number: '1583',
          title: '万+台',
          text: '回收设备数'
        },
        {
          image: require('../../assets/image/home/icon_paifangliang.png'),
          number: '128.3',
          title: '万+吨',
          text: '减少碳排放量'
        }
      ]
    }
  },
  methods: {
    changeIndex (index, item) {
      this.itemIndex = index
      // item.type === 1 ? this.$router.push(item.url) : window.open(item.url)
    }
  }
}
</script>

<style lang="less" scoped>
@media (max-width: 980px) {
  .home {
    width: 100%;
    padding: 0 24px;
    box-sizing: border-box;
    .content-item {
      display: flex;
      flex-direction: column;
      .content-items {
        padding-top: 55px;
        box-sizing: border-box;
        p {
          margin: 0;
          padding: 0;
          text-align: left;
          font-size: 32px;
        }
        .title {
          margin-bottom: 24px;
          font-size: 32px;
          line-height: 32px;
          color: #333;
          font-weight: 550;
        }
        .text {
          display: inline-block;
          width: 100%;
          color: #999;
          font-size: 24px;
          line-height: 24px;
          margin-bottom: 24px;
          text-align: left;
        }
        .service-list {
          display: flex;
          justify-content: space-between;
          .grade-item {
            width: 226px;
            height: 250px;
            display: flex;
            flex-direction: column;
            align-items: center;
            // justify-content: center;
            background: white;
            border-radius: 20px;
            img {
              width: 100px;
              height: 100px;
              margin-bottom: 11px;
              margin-top: 28px;
            }
            span {
              font-size: 24px;
              color: #666;
            }
            .grade-title {
              margin-bottom: 10px;
              .number {
                display: inline-block;
                font-size: 34px;
                line-height: 34px;
                font-family: DIN;
                color: #FF9600;
                margin-right: 8px;
              }
              span {
                color: #333;
                font-size: 30px;
                font-weight: 530;
              }
            }
          }
        }
      }
    }
  }
}
@media (min-width: 981px) {
  .home {
    width: 100%;
    .main-content {
      width: 100%;
      .white {
        background: white;
      }
      .gray {
        background: #F6F6F6;
      }
      .content-item {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .content-items {
        width: 1200PX;
        padding: 90PX 0;
        box-sizing: border-box;
        .title {
          font-size: 36PX;
          font-weight: 500;
          color: #111111;
          line-height: 36PX;
          text-align: center;
          margin: 0;
        }
        .text {
          display: inline-block;
          font-size: 22PX;
          margin-top: 20PX;
        }
        .service-list {
          margin-top: 55PX;
          display: flex;
          flex-wrap: wrap;
          align-content: space-between;
          // justify-content: space-between;
          // 服务
          .service-item {
            width: 282PX;
            height: 360PX;
            display: flex;
            flex-direction: column;
            background: #FFFFFF;
            border-radius: 20PX;
            margin-right: 24PX;
            img {
              width: 100%;
              height: 240PX;
            }
            .service-title {
              display: inline-block;
              font-size: 24PX;
              line-height: 24PX;
              margin: 28PX 0 17PX 0;
            }
          }
          .service-item:nth-child(4) {
            margin-right: 0;
          }
          // 业务规模
          .grade-item {
            width: 384PX;
            height: 310PX;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-right: 24PX;
            img {
              width: 160PX;
              height: 160PX;
              margin: 12PX 0 17PX 0;
            }
            span {
              font-size: 16PX;
              color: #666;
            }
            .grade-title {
              color: #333;
              margin-bottom: 21PX;
              display: flex;
              align-items: center;
              span {
                display: inline-block;
                font-size: 30PX;
                margin-left: 6PX;
              }
            }
            .number {
              display: inline-block;
              font-size: 42PX!important;
              line-height: 42PX;
              font-family: DIN;
              color: #FF9600;
            }
          }
          .grade-item:nth-child(3) {
            margin-right: 0;
          }
          // 合作伙伴
          .partner-item {
            width: 196PX;
            height: 64PX;
            margin: 0PX 55PX 0 0;
            text-align: center;
            line-height: 64PX;
            img {
              width: 100%;
              height: 100%;
            }
            span {
              font-size: 18PX;
              color: #999;
            }
          }
          .partner-item:nth-child(5n) {
            margin-right: 0;
          }
        }
      }
    }
  }
}
</style>
